import AddSeries from './AddSeries';

export default AddSeries;
